// The dashboard's accent hues (DESIGN.md, theme/rowcall.json): a few clear colours that tell kinds of things apart
// at a glance (each number on Home, each place in the sidebar, each outcome in a chart). They never mean status;
// status stays with Badge tones. Pages take a hue from here by name, never a colour of their own.
//
// Example: HUES.green → { tile: 'bg-hue-green-soft text-hue-green', text: 'text-hue-green', fill: 'bg-hue-green',
//   color: 'var(--hue-green)' }

export type Hue = 'blue' | 'teal' | 'green' | 'violet' | 'amber' | 'rose'

export type HueStyle = {
  /** A soft tinted tile with the icon in the full hue. */
  tile: string
  /** The hue as text (an icon on its own). */
  text: string
  /** The hue as a solid fill (a legend dot, a bar). */
  fill: string
  /** The hue as a value (a chart's line or bar). */
  color: string
}

// Written out whole so Tailwind sees and generates every class.
export const HUES: Record<Hue, HueStyle> = {
  blue: {
    tile: 'bg-hue-blue-soft text-hue-blue',
    text: 'text-hue-blue',
    fill: 'bg-hue-blue',
    color: 'var(--hue-blue)',
  },
  teal: {
    tile: 'bg-hue-teal-soft text-hue-teal',
    text: 'text-hue-teal',
    fill: 'bg-hue-teal',
    color: 'var(--hue-teal)',
  },
  green: {
    tile: 'bg-hue-green-soft text-hue-green',
    text: 'text-hue-green',
    fill: 'bg-hue-green',
    color: 'var(--hue-green)',
  },
  violet: {
    tile: 'bg-hue-violet-soft text-hue-violet',
    text: 'text-hue-violet',
    fill: 'bg-hue-violet',
    color: 'var(--hue-violet)',
  },
  amber: {
    tile: 'bg-hue-amber-soft text-hue-amber',
    text: 'text-hue-amber',
    fill: 'bg-hue-amber',
    color: 'var(--hue-amber)',
  },
  rose: {
    tile: 'bg-hue-rose-soft text-hue-rose',
    text: 'text-hue-rose',
    fill: 'bg-hue-rose',
    color: 'var(--hue-rose)',
  },
}

/** The hues in the order a chart takes them for its series, most distinct first. */
export const HUE_ORDER: Hue[] = ['blue', 'green', 'violet', 'amber', 'teal', 'rose']
